/* eslint-disable */

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCalculateModel,
  ICalculateRequest,
  IMappers,
  ICalculateResponse,
  ICalculateResponseError,
  TCalculateResponse,
} from './types';

const defaultConfig: TCalculateModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'investment-calculator-frontend',
  pathApi: '/v1/calculate/',
  hostType: 'api',
} as TCalculateModel;

function createCalculateModel(parameters: ICalculateRequest): TCalculateModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICalculateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICalculateRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCalculate<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICalculateOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TCalculateResponse> {
  const { response, statusCode } = await httpApi.fetch(createCalculateModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICalculateResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICalculateResponseError);
    }
  }

  return { response, statusCode } as TCalculateResponse;
}

export { defaultConfig, createCalculateModel, fetchCalculate };
